module.exports = __webpack_public_path__ + "static/how-to-use-2-3b585869c1976143f4b6d84123d8bf53.png";